module.exports = __webpack_public_path__ + "img/endeval-entreprise-petit.66a04500.png";